import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

export const openAdvancedFilter: ApiTableCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.advancedFilter.open = true;
    });
  };
